import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wheel } from 'react-custom-roulette';
import { prizeEn } from '../assets/data/prizeEN';
import { prizeFr } from '../assets/data/prizeFR';

import ring from '../assets/images/ring.png';
import ticker from '../assets/images/ticker.png';
import tickerBack from '../assets/images/ticker-back.png';
import pin from '../assets/images/pin.png';

import Button from './Button';

const WheelWrapper = ({ prizeData, setPrizeData, prizeNumber, setPrizeNumber, isSpinning, setSpinning }) => {
  const isPlayed = localStorage.getItem('is-played') ? JSON.parse(localStorage.getItem('is-played')) : false;

  const { i18n, t } = useTranslation();

  const navigate = useNavigate();

  const spinWheel = () => {
    if (!isSpinning) {
      setSpinning(true);

      const newPrizeNumber = Math.floor(Math.random() * prizeData.length);
      setPrizeNumber(newPrizeNumber);
    }
  };

  useEffect(() => {
    i18n.language === 'en' ? setPrizeData(prizeEn) : setPrizeData(prizeFr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <>
      {(isPlayed || isSpinning) && <div className="w-full h-[250px] absolute top-0 right-0 z-[100]"></div>}

      {prizeNumber >= 0 && !isSpinning ? (
        <h2 className="md:text-4xl lg:text-6xl text-[1.4rem] text-center md:m-10 m-4 relative z-20">
          {prizeNumber || prizeNumber === 0
            ? prizeData[prizeNumber]?.option
            : isPlayed
              ? t('thankYou')
              : t('spinAndWin')}
        </h2>
      ) : (
        <div className="md:text-4xl lg:text-6xl text-[1.4rem] text-center md:m-10 m-4 invisible">spinning</div>
      )}

      <div className="w-[100vw] h-[110vw] relative overflow-hidden z-20">
        <img src={tickerBack} alt="ticker_back" className="_ticker-back w-[28vw] _x-center top-0" />
        <img src={ring} alt="ring" className="_ring _center-center" />
        <img src={ticker} alt="ticker" className="_ticker w-[3.4vh] _x-center top-[1.8vw] z-10" />
        <img src={pin} alt="pin" className="_pin w-[18vw] _center-center z-20" />
        <Wheel
          data={prizeData}
          prizeNumber={prizeNumber}
          mustStartSpinning={isSpinning}
          spinDuration={0.48}
          textDistance={70}
          pointerProps={{ style: { opacity: '0' } }}
          onStopSpinning={() => {
            setSpinning(false);

            localStorage.setItem('is-played', true);
          }}
        />
      </div>

      <div
        className={`absolute lg:bottom-20 bottom-10 left-[50%] translate-x-[-50%] ${
          isSpinning && 'opacity-[0.6]'
        } z-40`}
      >
        {!isPlayed ? (
          <Button onClick={spinWheel}>{t('spin')}</Button>
        ) : (
          <Button onClick={() => navigate('/')}>{t('close')}</Button>
        )}
      </div>
    </>
  );
};

export default WheelWrapper;
